import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../UserAccountLinker.module.scss";

const AlreadyLinked = ({ senderOwner, emailUser }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.statusCard}>
      <h2>{t("invite.already_linked_title", { owner: senderOwner })}</h2>
      <p>
        {t("invite.already_linked_message", { owner: senderOwner })}
      </p>
    </div>
  );
};

export default AlreadyLinked;
